/* shto-scp-cart: the Santa Cruz Paleo cart drawer (sections/shto-scp-cart.liquid).
   Real Shopify cart: /cart/change.js and /cart/add.js, then the section is redrawn from the server through the Section
   Rendering API (the "sections" field of those calls), so every number on screen is Shopify's own.
   Takes over the theme's cart icon (#cart-drawer-toggle) and the theme drawer's open() (called by every theme
   add-to-cart form, quick add included), so anything added anywhere lands here. */
(() => {
  if (window.ShtoScpCart) return;
  const root = document.querySelector('[data-shto-cart]');
  if (!root) return;
  if (root.parentElement !== document.body) document.body.appendChild(root.closest('.shto-scp-cart-section') || root);

  const R = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const sectionId = root.dataset.sectionId;
  let lastFocus = null;
  let queue = Promise.resolve();

  const panel = () => root.querySelector('[data-shto-cart-panel]');
  const isOpen = () => root.hasAttribute('data-open');

  function open() {
    if (isOpen()) return;
    lastFocus = document.activeElement;
    root.setAttribute('data-open', '');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('shto-cart-lock');
    requestAnimationFrame(() => panel().focus({ preventScroll: true }));
    initCarousel();
    document.dispatchEvent(new CustomEvent('cart-drawer:open'));
  }
  function close() {
    if (!isOpen()) return;
    root.removeAttribute('data-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('shto-cart-lock');
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }

  function render(html) {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.querySelector('[data-shto-cart-panel]');
    const cur = panel();
    if (!next || !cur) return;
    const focusKey = document.activeElement && root.contains(document.activeElement) ? document.activeElement.dataset.shtoFocus : null;
    const bodyScroll = cur.querySelector('[data-shto-cart-body]')?.scrollTop || 0;
    const track = cur.querySelector('[data-shto-cart-track]');
    const trackScroll = track ? track.scrollLeft : 0;
    cur.innerHTML = next.innerHTML;
    const body = cur.querySelector('[data-shto-cart-body]');
    if (body) body.scrollTop = bodyScroll;
    const nt = cur.querySelector('[data-shto-cart-track]');
    if (nt) { nt.style.scrollBehavior = 'auto'; nt.scrollLeft = trackScroll; nt.style.scrollBehavior = ''; }
    initCarousel();
    if (isOpen() && focusKey) {
      const f = cur.querySelector(`[data-shto-focus="${CSS.escape(focusKey)}"]`);
      (f && !f.disabled ? f : cur).focus({ preventScroll: true });
    } else if (isOpen() && !cur.contains(document.activeElement)) {
      cur.focus({ preventScroll: true });
    }
  }

  function renderBubble(html) {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const n = doc.querySelector('.thb-item-count');
    const t = document.querySelector('#cart-drawer-toggle .thb-item-count');
    if (n && t) t.innerHTML = n.innerHTML;
  }

  function sectionsList() {
    return document.getElementById('cart-drawer-toggle') ? [sectionId, 'cart-bubble'] : [sectionId];
  }

  async function post(url, data) {
    const res = await fetch(R + url.replace(/^\//, ''), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...data, sections: sectionsList(), sections_url: window.location.pathname })
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok || json.status) throw Object.assign(new Error(json.description || json.message || 'Error'), { json });
    return json;
  }

  function applySections(sections) {
    if (!sections) return;
    render(sections[sectionId]);
    renderBubble(sections['cart-bubble']);
  }

  function run(job) { queue = queue.then(job, job); return queue; }

  async function refresh() {
    const res = await fetch(`${window.location.pathname}?sections=${encodeURIComponent(sectionsList().join(','))}`);
    if (!res.ok) return;
    applySections(await res.json());
  }

  function changeLine(li, quantity) {
    const key = li.dataset.shtoCartLine;
    li.setAttribute('data-busy', '');
    root.setAttribute('data-busy', '');
    return run(async () => {
      try {
        const cart = await post('cart/change.js', { id: key, quantity });
        applySections(cart.sections);
        document.dispatchEvent(new CustomEvent('line-item:change:end', { detail: { quantity, cart } }));
      } catch (e) {
        await refresh().catch(() => {});
        const again = root.querySelector(`[data-shto-cart-line="${CSS.escape(key)}"] [data-shto-cart-error]`);
        if (again) { again.textContent = e.message; again.hidden = false; }
      } finally {
        root.removeAttribute('data-busy');
      }
    });
  }

  function addVariant(btn, id) {
    btn.setAttribute('data-busy', '');
    btn.disabled = true;
    root.setAttribute('data-busy', '');
    return run(async () => {
      try {
        const res = await post('cart/add.js', { items: [{ id: Number(id), quantity: 1 }] });
        applySections(res.sections);
        root.querySelector('[data-shto-cart-body]')?.scrollTo({ top: 0, behavior: 'smooth' });
      } catch (e) {
        btn.disabled = false;
        btn.removeAttribute('data-busy');
        const span = btn.querySelector('span');
        if (span) { const was = span.textContent; span.textContent = e.message.length < 18 ? e.message : '!'; btn.title = e.message; setTimeout(() => { span.textContent = was; }, 2500); }
      } finally {
        root.removeAttribute('data-busy');
      }
    });
  }

  /* Upsell carousel: arrows step one card, the bar shows what's in view. */
  function initCarousel() {
    const box = root.querySelector('[data-shto-cart-carousel]');
    if (!box) return;
    const track = box.querySelector('[data-shto-cart-track]');
    const prev = box.querySelector('[data-shto-cart-prev]');
    const next = box.querySelector('[data-shto-cart-next]');
    const thumb = box.querySelector('[data-shto-cart-thumb]');
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      const ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
      if (thumb) {
        thumb.style.width = `${Math.min(100, ratio * 100)}%`;
        const pos = max > 0 ? track.scrollLeft / max : 0;
        thumb.style.transform = `translateX(${pos * (1 / ratio - 1) * 100}%)`;
      }
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      box.querySelector('.shto-scp-cart__arrows')?.toggleAttribute('hidden', max <= 2);
      box.querySelector('.shto-scp-cart__upsell-bar')?.toggleAttribute('hidden', max <= 2);
    };
    if (!track.dataset.shtoBound) {
      track.dataset.shtoBound = '1';
      track.addEventListener('scroll', update, { passive: true });
      const step = (dir) => {
        const card = track.querySelector('[data-shto-cart-card]');
        const gap = parseFloat(getComputedStyle(track).columnGap) || 12;
        track.scrollBy({ left: dir * ((card ? card.offsetWidth : 280) + gap), behavior: 'smooth' });
      };
      prev?.addEventListener('click', () => step(-1));
      next?.addEventListener('click', () => step(1));
    }
    update();
  }

  /* Clicks. Capture phase on the cart icon so the theme's own drawer never opens. */
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('#cart-drawer-toggle, [data-shto-cart-open]');
    if (toggle && !root.contains(toggle)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      open();
      run(refresh);
    }
  }, true);

  root.addEventListener('click', (e) => {
    if (e.target.closest('[data-shto-cart-close]')) { close(); return; }
    const q = e.target.closest('[data-shto-cart-qty]');
    if (q && !q.disabled) {
      const li = q.closest('[data-shto-cart-line]');
      const qty = Math.max(0, Number(li.dataset.qty) + Number(q.dataset.shtoCartQty));
      li.dataset.qty = String(qty);
      const n = li.querySelector('.shto-scp-cart__qty span');
      if (n) n.textContent = qty;
      changeLine(li, qty);
      return;
    }
    const rm = e.target.closest('[data-shto-cart-remove]');
    if (rm) { changeLine(rm.closest('[data-shto-cart-line]'), 0); return; }
    const add = e.target.closest('[data-shto-cart-add]');
    if (add && !add.disabled) {
      const sel = add.closest('[data-shto-cart-card]').querySelector('[data-shto-card-variant]');
      addVariant(add, sel ? sel.value : add.dataset.shtoCartAdd);
    }
  });

  root.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-shto-card-variant]');
    if (!sel) return;
    const opt = sel.options[sel.selectedIndex];
    const price = sel.closest('[data-shto-cart-card]').querySelector('[data-shto-card-price]');
    if (opt && price && opt.dataset.price) price.textContent = opt.dataset.price;
  });

  document.addEventListener('keydown', (e) => {
    if (!isOpen()) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    const items = [...panel().querySelectorAll('a[href], button:not([disabled]), select, input, [tabindex]:not([tabindex="-1"])')].filter((el) => el.offsetParent !== null);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || !panel().contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* The theme's add-to-cart forms call document.getElementById('Cart-Drawer').open() after adding. */
  function hijackThemeDrawer() {
    const hab = document.getElementById('Cart-Drawer');
    if (!hab || hab.dataset.shtoHijacked) return;
    hab.dataset.shtoHijacked = '1';
    hab.open = () => { open(); run(refresh); };
  }
  hijackThemeDrawer();
  customElements.whenDefined('cart-drawer').then(hijackThemeDrawer);
  document.addEventListener('cart:refresh', () => run(refresh));

  window.ShtoScpCart = { open, close, refresh: () => run(refresh) };
  if (/[?&]shto_cart=open\b/.test(window.location.search)) open();
})();
